import React, { useEffect, useState } from 'react';
import { Button, Dialog, T, useTranslation } from '@colonist/ui';
import { TextInput } from '@colonist/ui-platform';
import styles from './DeleteAccountDialog.module.scss';
const MAX_USERNAME_INPUT_LENGTH = 100;
/** Account deletion confirmation dialog. */ export const DeleteAccountDialog = ({ open, onClose, username, onConfirm })=>{
    const { t } = useTranslation();
    const [inputtedUsername, setInputtedUsername] = useState('');
    const canDelete = inputtedUsername.trim().length > 0;
    useEffect(()=>{
        if (!open) setInputtedUsername('');
    }, [
        open
    ]);
    const handleConfirm = ()=>{
        if (!canDelete) return;
        onConfirm(inputtedUsername);
        onClose();
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        handleConfirm();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "md"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:profilePage.deleteAccount.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("p", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:profilePage.deleteAccount.body',
            options: {
                username: username
            }
        }
    })), /*#__PURE__*/ React.createElement("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React.createElement(TextInput, {
        value: inputtedUsername,
        onChange: (event)=>setInputtedUsername(event.target.value),
        placeholder: t('strings:profilePage.deleteAccount.inputPlaceholder'),
        maxLength: MAX_USERNAME_INPUT_LENGTH,
        autoFocus: true,
        autoComplete: "off"
    }))), /*#__PURE__*/ React.createElement(Dialog.Footer, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: onClose
    }), /*#__PURE__*/ React.createElement(Button, {
        variant: "danger",
        size: "md",
        fullWidth: true,
        disabled: !canDelete,
        onClick: handleConfirm
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:profilePage.deleteAccount.button'
        }
    }))));
};
